import { Box } from '@mui/material';
import styled from 'styled-components';

export const SearchContainer = styled(Box)(() => ({
  display: 'flex',
  gap: 16,
  width: '100%',
  alignItems: 'flex-end',
  flexWrap: 'wrap'
}));
